import { gearsRobotsTxtLoader as Ae } from "./lib.gears-robots-txt.es.js";
import { gearsSitemapIndexLoader as Ne } from "./lib.gears-sitemap-index.es.js";
import { gearsSitemapLoader as qe } from "./lib.gears-sitemap.es.js";
import { gearsStatusLoader as Oe } from "./lib.gears-status.es.js";
import { useLocation as Y, useRouteLoaderData as j } from "@remix-run/react";
import { useState as ee, useEffect as te } from "react";
import { createCookie as oe, redirect as ne, json as ae } from "@remix-run/node";
import { fetchPage as re, fetchSettingsAndContent as se } from "@made-people/gears-bff-client";
import { shouldHandleUrl as W, normalizeSlug as ie } from "@made-people/gears-utils";
import { toGearsEnvironmentOrUndefined as ce, getGearsConfigurationVariable as _, toGearsDomainOrUndefined as le, toGearsRunModeOrUndefined as de, toGearsLocalServicesOrUndefined as pe, toGearsClusterModeOrUndefined as ue } from "@made-people/gears-configuration";
import { isStoryblokPreviewRequestQuery as fe } from "@made-people/gears-storyblok";
const xe = () => Y(), Le = () => {
  const o = j("root");
  if (o !== null)
    return o;
}, De = (o) => {
  const t = Y(), [n, e] = ee("");
  te(() => {
    n !== t.pathname && (o(), e(t.pathname));
  }, [n, t.pathname]);
};
function B(o) {
  const t = {};
  return Object.keys(o).forEach((n) => {
    const e = n.indexOf("[");
    if (e !== -1) {
      const i = n.substring(0, e), l = n.substring(e + 1, n.length - 1);
      t[i] || (t[i] = {}), t[i][l] = o[n];
    } else
      t[n] = o[n];
  }), t;
}
const me = (o) => {
  const t = {};
  for (const [n, e] of o)
    t[n] = e;
  return t;
};
async function ge(o) {
  let t = {};
  try {
    const n = await o.formData();
    let e = {};
    for (const [c, r] of n.entries())
      typeof r == "string" && (e[c] = r);
    t = B(e);
    const i = me(
      new URLSearchParams(o.url.split("?")[1])
    ), l = B(i);
    Object.assign(t, l);
  } catch {
  }
  return t;
}
const Ue = (o) => o.split(";").map((t) => t.split("=")).reduce(
  (t, n) => (n[0] && n[1] && (t[decodeURIComponent(n[0].trim())] = decodeURIComponent(
    n[1].trim()
  )), t),
  {}
);
async function ve({ request: o }) {
  return {
    paymentMethodFields: await ge(
      // see https://github.com/remix-run/remix/pull/8062 for why we need to cast this
      o
    )
  };
}
const Q = "x-campaign-site-key", he = async (o, t) => {
  var g;
  const n = new URL(o.request.url);
  if (!W(n))
    throw new Response("404 /build/ should not be served by me", {
      status: 404
    });
  const e = oe(Q, {
    maxAge: 604800
    // one week
  }), i = o.request.headers.get("Cookie"), l = await e.parse(i);
  l && o.request.headers.set(Q, l);
  const c = await re(n, o.request.headers);
  if (!c)
    throw new Response("Service Unavailable", {
      status: 500
    });
  const { page: r } = c;
  switch (r.pageType) {
    case "rawResponse":
      throw new Response(r.content, {
        status: r.statusCode,
        headers: {
          "content-type": r.contentType
        }
      });
    case "redirect":
      throw ne(r.location, r.statusCode);
  }
  const s = new Headers();
  return c.frontendContext.campaignSite ? s.set(
    "Set-Cookie",
    await e.serialize(
      c.frontendContext.campaignSite.key
    )
  ) : typeof l == "string" && !c.frontendContext.campaignSite && s.set(
    "Set-Cookie",
    await e.serialize("", {
      maxAge: 0,
      expires: /* @__PURE__ */ new Date(0)
    })
  ), (g = r == null ? void 0 : r.headers) != null && g["cache-control"] && s.set("Cache-Control", r.headers["cache-control"]), t ?? (t = {}), {
    loaderData: { pageResponse: c, customExtraData: t },
    responseInit: {
      status: r.statusCode,
      headers: s
    }
  };
};
function _e(o) {
  return ae(o.loaderData, o.responseInit);
}
const Ee = async (o, t) => _e(
  await he(o, t)
), Te = ({ data: o, matches: t }) => {
  var U, v, E, T, I, $, P, A, M, N, G, q, H, O, z, F, K;
  const n = o.pageResponse, e = n == null ? void 0 : n.page;
  if (!e || !e.pageType || e.pageType === "rawResponse" || e.pageType === "redirect")
    return [];
  const i = (v = (U = t.find((a) => a.id === "root")) == null ? void 0 : U.data) == null ? void 0 : v.settingsAndContentResponse, l = i == null ? void 0 : i.frontendContext;
  let c = "";
  l ? c = l.baseUrl : console.warn(
    "Didn't receive frontendContext in settingsAndContentResponse, cannot resolve baseURL"
  );
  const r = (E = i == null ? void 0 : i.globalStoryblokStories) == null ? void 0 : E.find(
    (a) => a.lookupConfiguration.lookupType === "slug" && a.lookupConfiguration.slug === "shared-content/settings/general"
  );
  r != null && r.content[0] || console.warn(
    "No SB general settings were found, default meta data from SB cannot be used"
  );
  const {
    default_meta_description: s,
    checkout_meta_title: g,
    checkout_success_meta_title: w,
    search_page_meta_title: S,
    account_page_meta_title: C,
    account_login_meta_title: R,
    restore_password_meta_title: b,
    pdp_meta_title_suffix: X,
    pdp_meta_title_prefix: Z,
    meta_title_suffix: x,
    meta_title_prefix: L,
    openGraphImage: y
  } = ((T = r == null ? void 0 : r.content) == null ? void 0 : T[0]) || {}, u = [];
  let h = (y == null ? void 0 : y.filename) || "", d, p, f, m;
  switch (e.pageType) {
    case "checkoutIndex":
    case "checkoutFinalize":
      d = g || "", p = s || "", f = g || "", m = s || "";
      break;
    case "searchPage":
      d = S || "", p = s || "", f = S || "", m = s || "";
      break;
    case "accountIndex":
      d = C || "", p = s || "", f = C || "", m = s || "";
      break;
    case "accountLogin":
      d = R || "", p = s || "", f = R || "", m = s || "";
      break;
    case "forgotPassword":
      d = b || "", p = s || "", f = b || "", m = s || "";
      break;
    case "checkoutReceipt":
      d = w || "", p = s || "", f = w || "", m = s || "";
      break;
    case "centraProductPage":
      d = `${Z || ""}${((I = e.meta) == null ? void 0 : I.title) || ""}${X || ""}`, p = (($ = e.meta) == null ? void 0 : $.description) || "", f = (P = e.meta) == null ? void 0 : P.title, m = (A = e.meta) == null ? void 0 : A.description, h = ((M = e.productData) == null ? void 0 : M.mediaUrls.length) && e.productData.mediaUrls[0] || h;
      break;
    case "storyblokPage":
      const a = (G = (N = e.storyblokData) == null ? void 0 : N.content) == null ? void 0 : G.seo, J = (a == null ? void 0 : a.title) || ((q = e.meta) == null ? void 0 : q.title) || "", V = (a == null ? void 0 : a.description) || s || ((H = e.meta) == null ? void 0 : H.description) || "";
      d = `${L || ""}${J}${x || ""}`, p = V || (a == null ? void 0 : a.og_description), f = (a == null ? void 0 : a.og_title) || J, m = (a == null ? void 0 : a.og_description) || V, h = (a == null ? void 0 : a.og_image) || h;
      break;
    default:
      d = `${L || ""}${((O = e.meta) == null ? void 0 : O.title) || ""}${x || ""}`, p = ((z = e.meta) == null ? void 0 : z.description) || "", m = (F = e.meta) == null ? void 0 : F.description, f = (K = e.meta) == null ? void 0 : K.title;
      break;
  }
  u.push({ title: d }), u.push({ name: "description", content: p }), u.push({ property: "og:title", content: f || d }), u.push({
    property: "og:url",
    content: `${c}${e.meta.canonicalUrl}`
  }), u.push({
    property: "og:description",
    content: m || p
  }), h && u.push({ property: "og:image", content: h }), e.meta.canonicalUrl && u.push({
    tagName: "link",
    rel: "canonical",
    href: `${c}${e.meta.canonicalUrl}`
  });
  for (const a of e.meta.hreflangLocales)
    u.push({
      tagName: "link",
      rel: "alternate",
      hrefLang: a.hreflang,
      href: `${c}${a.url}`
    });
  const k = [];
  e.meta.noIndex && k.push("noindex"), e.meta.noFollow && k.push("nofollow");
  const D = k.join(",");
  return D && u.push({ name: "robots", content: D }), u;
}, Ie = async (o) => {
  const t = new URL(o.request.url);
  t.pathname = ie(t.pathname);
  const [, n] = t.pathname.split("/");
  if (!W(t) || n === "" || n === void 0)
    return null;
  const e = await se(
    n,
    o.request.headers
  );
  if (!e)
    return null;
  const i = ce(
    _("gearsEnvironment")
  );
  if (typeof i > "u")
    throw new Error("GEARS_ENVIRONMENT variable isn't set.");
  const l = _("tenantId");
  if (typeof l > "u")
    throw new Error("TENANT_ID variable isn't set.");
  const c = le(
    _("gearsDomain")
  ), r = de(
    _("gearsRunMode")
  ), s = pe(
    _("localServices")
  ), g = ue(
    _("gearsClusterMode")
  ), w = !!process.env.JOTAI_DEVTOOLS;
  return {
    settingsAndContentResponse: e,
    insideStoryblokPreview: fe(
      Object.fromEntries(t.searchParams.entries())
    ),
    gearsConfiguration: {
      tenantId: l,
      gearsEnvironment: i,
      localServices: s,
      gearsRunMode: r,
      gearsClusterMode: g,
      gearsDomain: c
    },
    jotaiDevtoolsEnabled: w
  };
};
export {
  ge as convertPostAndGetToJSON,
  _e as createGearsLoaderResponse,
  ve as gearsAction,
  Ee as gearsLoader,
  Te as gearsMeta,
  Ae as gearsRobotsTxtLoader,
  Ie as gearsRootLoader,
  Ne as gearsSitemapIndexLoader,
  qe as gearsSitemapLoader,
  Oe as gearsStatusLoader,
  Ue as parseCookie,
  he as resolveGearsResult,
  B as toJSON,
  xe as useLocation,
  Le as useRootLoaderData,
  De as useRouteChanged
};
//# sourceMappingURL=lib.index.es.js.map
